import { useAuthState } from './hooks/useAuth';
import { initialAuthContext } from './types/auth';
export const useAuthHelper = () => {
    return useAuthState(initialAuthContext);
};
export const routeIsRender = (route) => route.action === 'render';
export const getAvailableRoutes = (ctx) => ctx.routingConfig.routeSets.flatMap(set => set.available(ctx));
// Find matching route by checking paths from longest to shortest
export const findMatchingRoute = (routes, routeCurrent) => {
    return routes
        .toSorted((a, b) => b.path.length - a.path.length) // TODO: suspicious, no?
        .map(route => route.match(routeCurrent.ismatch))
        .find(match => match !== null) || null;
};
// Check and execute invalid access handlers (redirects or fallbacks)
export const executeInvalidAccessHandler = (ctx, navigate) => {
    // Check all route set invalid access handlers
    for (const routeSet of ctx.routingConfig.routeSets) {
        const handler = routeSet.onInvalidAccess.find(h => h.when(ctx));
        if (handler) {
            if (handler.action === 'redirect') {
                navigate(handler.target());
                return { 'action': 'redirect' };
            }
            return { 'action': 'render', 'component': handler.component };
        }
    }
    // Check default fallback
    const defaultHandler = ctx.routingConfig.defaultFallback;
    if (defaultHandler.when(ctx)) {
        return { 'action': 'render', 'component': defaultHandler.component };
    }
    return { 'action': 'none' };
};
export const httpErrors = {
    400: 'Bad request. Please check your input.',
    403: 'You don\'t have permission to do that.',
    404: 'The requested resource was not found.',
    408: 'Request timed out. Please try again.',
    409: 'Conflict — this resource was modified by someone else.',
    429: 'Too many requests. Please slow down.',
    500: 'Something went wrong on the server.',
    502: 'Server is temporarily unavailable.',
    503: 'Service is under maintenance. Try again shortly.',
    504: 'Server took too long to respond.',
};
